import { createSelector } from '@reduxjs/toolkit';

import { IState } from '../../store';

const getBanksList = (state: IState) => state.banksList.list;
const getMortgageBankIds = (state: IState) => state.mortgage.bankIds;

export const banksListSelector = createSelector([getBanksList, getMortgageBankIds], (banksList, bankIds) => {
  if (!bankIds) {
    return banksList;
  }
  const actualBankIds = new Set(bankIds);

  return banksList.filter(bank => actualBankIds.has(bank.id));
});
